import {CoingeckoDexNamesEnum, DexNamesEnum} from "@shared/enums/dex-names.enum";
import {CexNamesEnum, NetworkNamesEnum} from "@shared/enums/networks.enum";

export interface CoingeckoDex {
    dex: DexNamesEnum
    coingeckoDex: CoingeckoDexNamesEnum
    network: NetworkNamesEnum
    platformNetworkName: CoingeckoNetworks
}

export enum CoingeckoNetworks {
    Ethereum = 'ethereum',
    Avalanche = 'avalanche',
    BSC = 'binance-smart-chain',
    Harmony = 'harmony-shard-0',
    Polygon = 'polygon-pos',
    Fantom = 'fantom',
    HECO = 'huobi-token',
    Optimism = 'optimistic-ethereum',
    Arbitrum = 'arbitrum-one',
    Celo = 'celo',
    Solana = 'solana',
    Base = 'base',
    Blast = 'blast',
    ZkSync = 'zksync',
    Ton = 'ton',
    Saakuru = 'saakuru-mainnet',
    Tron = 'tron',
    Mode = 'mod',
    Mantle = 'mantle',
    Sui = 'sui-network',
    Kaia = 'klaytn',
    Unit = 'units-network',
    Kava = 'kava',
    Xrp = 'xrp',
    Berachain = 'berachain',
    Soneium = 'soneium',
    Sonic = 'sonic',
    Hyperevm = 'hyperevm',
}

export enum CoingeckoCexes {
    'gateio' = 'gate',
    'binance' = 'binance',
    'mexc' = 'mxc',
    'huobipro' = 'htx',
    'kucoin' = 'kucoin',
    'whitebit' = 'whitebit',
    'okx' = 'okex',
    'bitmart' = 'bitmart',
    'bybit' = 'bybit_spot',
    'bitget' = 'bitget',
    'bingx' = 'bingx',
    'coinbase' = 'coinbase-exchange',
    'p2b' = 'p2b',
    'woo' = 'woo-network',
    'lbank' = 'lbank',
    'xt' = 'xt',
    'bitrue' = 'bitrue',
    'ascendex' = 'ascendex',
    'blofin' = 'blofin-spot',
    'weex' = 'weex',
    'biconomy' = 'biconomy-com',
    'btse' = 'btse',
    'coinstore' = 'coinstore',
}

export const COINGECKO_CEX = [
    {
        cex: CexNamesEnum.gateio,
        coingeckoCex: CoingeckoCexes.gateio,
    },
    {
        cex: CexNamesEnum.binance,
        coingeckoCex: CoingeckoCexes.binance,
    },
    {
        cex: CexNamesEnum.mexc,
        coingeckoCex: CoingeckoCexes.mexc,
    },
    {
        cex: CexNamesEnum.huobipro,
        coingeckoCex: CoingeckoCexes.huobipro,
    },
    {
        cex: CexNamesEnum.kucoin,
        coingeckoCex: CoingeckoCexes.kucoin,
    },
    {
        cex: CexNamesEnum.whitebit,
        coingeckoCex: CoingeckoCexes.whitebit,
    },
    {
        cex: CexNamesEnum.okx,
        coingeckoCex: CoingeckoCexes.okx,
    },
    {
        cex: CexNamesEnum.bitmart,
        coingeckoCex: CoingeckoCexes.bitmart,
    },
    {
        cex: CexNamesEnum.bybit,
        coingeckoCex: CoingeckoCexes.bybit,
    },
    {
        cex: CexNamesEnum.bitget,
        coingeckoCex: CoingeckoCexes.bitget,
    },
    {
        cex: CexNamesEnum.bingx,
        coingeckoCex: CoingeckoCexes.bingx,
    },
    {
        cex: CexNamesEnum.coinbase,
        coingeckoCex: CoingeckoCexes.coinbase,
    },
    {
        cex: CexNamesEnum.p2b,
        coingeckoCex: CoingeckoCexes.p2b,
    },
    {
        cex: CexNamesEnum.woo,
        coingeckoCex: CoingeckoCexes.woo,
    },
    {
        cex: CexNamesEnum.lbank,
        coingeckoCex: CoingeckoCexes.lbank,
    },
    {
        cex: CexNamesEnum.xt,
        coingeckoCex: CoingeckoCexes.xt,
    },
    {
        cex: CexNamesEnum.bitrue,
        coingeckoCex: CoingeckoCexes.bitrue,
    },
    {
        cex: CexNamesEnum.ascendex,
        coingeckoCex: CoingeckoCexes.ascendex,
    },
    {
        cex: CexNamesEnum.blofin,
        coingeckoCex: CoingeckoCexes.blofin,
    },
    {
        cex: CexNamesEnum.weex,
        cocoingeckoCex: CoingeckoCexes.weex,
    },
    {
        cex: CexNamesEnum.biconomy,
        cocoingeckoCex: CoingeckoCexes.biconomy,
    },
    {
        cex: CexNamesEnum.btse,
        cocoingeckoCex: CoingeckoCexes.btse,
    },
    {
        cex: CexNamesEnum.coinstore,
        cocoingeckoCex: CoingeckoCexes.coinstore,
    },
]
